import React, { useEffect, useState } from "react";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { Navigate, useNavigate } from "react-router-dom";

import { getCurrentLang, getUrlLangPrefix } from "@/utils/Local";

import CheckoutFormComponent from "../components/CheckoutForm.component";
import useCart from "../hooks/useCart";
import i18n from "../i18n";
import apiService from "../services/api";

import type { StripeElementsOptions } from "@stripe/stripe-js";

const stripePromise = loadStripe(import.meta.env.VITE_STRIPE_PUBLIC_KEY ?? "", {
  locale: getCurrentLang(),
});

const Checkout = (): React.JSX.Element => {
  const { t } = i18n;
  const navigate = useNavigate();
  const [clientSecret, setClientSecret] = useState("");
  const { dispatch, REDUCER_ACTIONS, cart } = useCart();

  const preparePayment = async () => {
    if (cart.items && cart.items.length > 0) {
      try {
        const response = await apiService.checkout(cart);
        if (response?.data?.cart) {
          dispatch({
            type: REDUCER_ACTIONS.UPDATE,
            updatedCart: response.data.cart,
          });
          setClientSecret(response.data.cart.clientSecret);
        }
      } catch (error) {
        navigate(`${getUrlLangPrefix()}/${t("_route.error")}`);
      }
    }
  };

  useEffect(() => {
    preparePayment();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const appearance = {
    theme: "stripe",
  };

  const options = {
    clientSecret,
    appearance,
  } as StripeElementsOptions;

  if (!cart.items || cart.items.length < 1) {
    return <Navigate to={`${getUrlLangPrefix()}/${t("_route.shop")}`} />;
  }

  return (
    <React.Fragment>
      {clientSecret ? (
        <Elements options={options} stripe={stripePromise}>
          <CheckoutFormComponent />
        </Elements>
      ) : null}
    </React.Fragment>
  );
};

export default Checkout;
